import { MAGNOLIA_NEXT_API_URL, MAGNOLIA_PHONE_NUMBER_URL } from "@/constants";
import logError from "@/utils/logger";

interface PhoneNumberEntry {
  name: string;
  default: string;
  desktop: string;
  mobile: string;
  "@path": string;

  callingFromTheUK: string;
  callingFromOutsideTheUK: string;
  callingFromMexico: string;
  callingFromUSAorCanada: string;
  nonEmergencyClaims: string;
  medicalAssistanceInEurope: string;
  medicalAssistanceWithinTheUSAandCanada: string;
}

interface PhoneNumberResponse {
  total: number;
  offset: number;
  limit: number;
  results: PhoneNumberEntry[];
}

const fetchPhoneNumberData = async (): Promise<PhoneNumberResponse> => {
  try {
    const fetchURL = `${MAGNOLIA_NEXT_API_URL}/${MAGNOLIA_PHONE_NUMBER_URL}`;
    const response = await fetch(fetchURL);
    const res = await response.json();
    return res.data;
  } catch (error) {
    if (error instanceof Error) {
      logError(error, { location: "fetchPhoneNumber.tsx" });
    } else {
      logError(new Error("An unknown error occurred"), {
        location: "fetchPhoneNumber.tsx",
      });
    }
    return { total: 0, offset: 0, limit: 0, results: [] };
  }
};

export default fetchPhoneNumberData;
